<template>
  <div>
    <Tabs type="card" v-model="current" :animated="false">
      <TabPane label="解约信息" name="releaseInfo" disabled>
        <keep-alive>
          <realease-info @todelivery="todelivery" :data="surBaseInfo" :list2="certTypeList" v-if="surBaseInfo"></realease-info>
        </keep-alive>
      </TabPane>
      <TabPane label="交割信息" name="deliveryInfo" disabled>
        <keep-alive>
          <delivery-info
            :surrenderFid="surFid"
            :parentSurrenderFid="parentSurrenderFid"
            @tosettle="tosettle"
            @torelease="torelease"
            :projectName="projectName"
            v-if="surFid && parentSurrenderFid"
          ></delivery-info>
        </keep-alive>
      </TabPane>
      <TabPane label="结算信息" name="settleInfo" disabled>
        <keep-alive>
          <settle-info @tolast="settletodelivery"
                       v-if="surFid&&surBaseInfo"
                       :n1="settleN"
                       :surFid="surFid"
                       :parentSurrenderFid="parentSurrenderFid"
                       :stockStatus="stockStatus"
                       :stockRentDate="stockRentDate"
                       :surBaseInfo="surBaseInfo"
          ></settle-info>
        </keep-alive>
      </TabPane>
    </Tabs>
  </div>

</template>
<script>
  import RealeaseInfo from './components/ReleaseInfo'
  import SettleInfo from './components/SettleInfo'
  import DeliveryInfo from './components/DeliveryInfo'
  import {getEnterpriseSurrenderInitInfo} from "../../../../api/contractList"

  export default {
    name: "releasebusiness1",
    components: {
      RealeaseInfo,
      SettleInfo,
      DeliveryInfo
    },
    data() {
      return {
        projectName: '',
        settleN: 0,
        isSend: false,
        surFid: '',
        current: 'releaseInfo',
        parentSurrenderFid: '',
        stockStatus: '',
        stockRentDate: '',
        surrenderFid: '',
        stockNumber:'',
        surBaseInfo: null,
        certTypeList:[],
      }
    },
    methods: {
      settletodelivery() {
        this.current = 'deliveryInfo'
      },
      todelivery(params) {
        params.parentSurrenderFid && (this.parentSurrenderFid = params.parentSurrenderFid)
        params.surFid && (this.surFid = params.surFid)
        this.stockStatus = params.stockStatus;
        this.stockRentDate = params.stockRentDate;
        params.projectName && (this.projectName = params.projectName)
        // params.stockNumber && (this.stockNumber=stockNumber)
        this.current = 'deliveryInfo'
      },
      tosettle() {
        // this.isSend=true
        this.settleN++
        this.current = 'settleInfo'
      },
      torelease() {
        this.current = 'releaseInfo'
      }
    },
    created(){
      this.contractId = this.$route.params.id
      let params = {
        contractId: this.contractId
      }
      getEnterpriseSurrenderInitInfo(params).then(res => {
        if(!res.data){
          return
        }
        this.surBaseInfo = res.data
        this.certTypeList = res.data.certTypeList
      }).catch(error => {})
    }
  }
</script>

<style scoped>

</style>
